module.exports = __webpack_public_path__ + "df1eaa652bac46208b03b0de3667d324.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/empresa2.png
// module id = 639
// module chunks = 0